import React, { Suspense, useEffect, useState } from "react";
import Loader from "../component/Loader";
import EmptyState from "../component/EmptyState";
import { getPlatformToken } from "../services/platform";
const PlatformConsole = React.lazy(() => import("../app/platform/PlatformConsole"));

/**
 * The PayLoom console's own entry point, outside the tenant app.
 *
 * It mints a platform-scoped session before rendering anything. That token
 * carries no organisation and the server REFUSES it on tenant routes, which is
 * the containment this tier depends on — so it replaces the tenant bearer for
 * as long as somebody is in here. Going back to /app mints a tenant token
 * again on mount, so the two correct themselves rather than needing a sign-out
 * between them.
 *
 * A refusal renders a flat "not available" rather than redirecting to login:
 * somebody signed in as an ordinary admin who guesses this URL should learn
 * nothing from how it answers, including whether a console exists.
 */
function Platform() {
  const [state, setState] = useState("loading"); // loading | ready | denied

  useEffect(() => {
    let active = true;
    getPlatformToken()
      .then((res) => {
        if (!active) return;
        setState(res?.success ? "ready" : "denied");
      })
      .catch(() => active && setState("denied"));
    return () => { active = false; };
  }, []);

  if (state === "loading") return <Loader />;
  if (state === "denied") {
    return (
      <EmptyState
        variant="forbidden"
        title="Not available"
        description="This area is for PayLoom staff."
      />
    );
  }

  return (
    <Suspense fallback={<Loader />}>
      <PlatformConsole />
    </Suspense>
  );
}

export default Platform;
